import React from 'react'
import { Form } from "../../plugins/gatsby-plugin-atollon";
import { Loading, Upload, File } from './icons';
import Select from 'react-select'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Authoritative venue -> TripleSeat lead-form-id / location-id (from DatoCMS Venue model).
// Venues not listed here have no TripleSeat lead form -> those event enquiries are emailed.
const VENUE_TO_FORMID = {
  "The Terrace": "29254",
  "Higher Ground": "29253",
  "The Observatory": "38906",
  "Top Paddock": "29250",
  "Kettle Black": "29252",
  "Cheri": "40693",
};

const VENUE_TO_LOCATIONID = {
  "The Terrace": "23679",
  "Higher Ground": "23678",
  "The Observatory": "29732",
};

const FormComponent = (props) => {
  const [startDate, setStartDate] = React.useState(null);

  // Keep lead-form-id in state so we can update it when venue changes
  const initialLeadFormId =
    props.leadFormId ??
    (props.title && VENUE_TO_FORMID[props.title]) ??
    undefined;

  const [leadFormId, setLeadFormId] = React.useState(initialLeadFormId);

  const initialLocationId =
    props.locationId ??
    (props.title && VENUE_TO_LOCATIONID[props.title]) ??
    undefined;

  const [locationId, setLocationId] = React.useState(initialLocationId);

  // 1) State for UTM values to add to hidden fields
  const [utmValues, setUtmValues] = React.useState({});

  // 2) Read from sessionStorage on mount (client-side only)
  React.useEffect(() => {
    if (typeof window === "undefined") return;

    const stored = sessionStorage.getItem("utmParams");
    if (!stored) return;
    if (!props.pageUrl) return;

    try {
      const utmParams = JSON.parse(stored);

      // Map utm_* keys to your hidden field names
      const mapped = {};

      if (utmParams.utm_source)   mapped.utmsource   = utmParams.utm_source;
      if (utmParams.utm_medium)   mapped.utmmedium   = utmParams.utm_medium;
      if (utmParams.utm_campaign) mapped.utmcampaign = utmParams.utm_campaign;
      if (utmParams.utm_term)     mapped.utmterm     = utmParams.utm_term;
      if (utmParams.utm_content)  mapped.utmcontent  = utmParams.utm_content;

      setUtmValues(mapped);
    } catch (e) {
      console.error("Failed to parse utmParams from sessionStorage", e);
    }
  }, []);

  // Your existing static values
  const staticValues = {};
  if (props.jobTitle) staticValues["job-title"] = props.jobTitle;
  if (props.title) staticValues["venue"] = props.title;
  if (props.fbclid) staticValues["fbclid"] = props.fbclid;
  if (props.pageUrl) staticValues["page-url"] = props.pageUrl;
  if (props.leadSource) staticValues["lead-source"] = props.leadSource;

  // IMPORTANT: pass the reactive id into values
  // 3) Merge staticValues + utmValues + lead-form-id
  const values = {
    ...staticValues,
    ...utmValues,
    "lead-form-id": leadFormId,
    "location-id": locationId,
  };

  return (
    <Form
      schema={props.form}
      onPreSubmit={props.onPreSubmit}
      onSubmitSuccess={props.onSubmitSuccess}
      values={values}
      renderField={(field) => {
        if (field.type === "text" || field.type === "email" || field.type === "tel") {
          let defaultValue = field.label === 'Product' ? props.title : undefined
          let defaultType = (field.label === 'Product') ? 'hidden' : field.type

          if (field.name === 'event-date' ) {
            const handleDateChange = (e) => {
              const event = { target: { name: field.name, value: e } };
              setStartDate(e);
              field.onChange(event);
            };
            return (
              <div className={`form__text${field.label === 'Product' ? ' form__hidden' : ''} form__text--${field.name}`}>
                <DatePicker
                  name={field.name}
                  id={field.id}
                  selected={startDate}
                  placeholderText={defaultValue ? defaultValue : field.placeholder}
                  onChange={handleDateChange}
                />
              </div>
            )
          }

          return (
            <div className={`form__text${field.label === 'Product' ? ' form__hidden' : ''} form__text--${field.name}`}>
              <label htmlFor={field.id}>{field.label}</label>
              <input
                ref={field.ref}
                onBlur={field.onBlur}
                onChange={field.onChange}
                name={field.name}
                type={field.name === 'number-of-guests' ? 'number' : defaultType}
                defaultValue={defaultValue}
                id={field.id}
                maxLength={field.label === 'Postcode' ? 6 : undefined}
                autoComplete={field.autoComplete}
                placeholder={defaultValue ? defaultValue : field.placeholder}
                aria-required={field.required}
                disabled={field.label === 'Product' ? true : field.disabled}
                aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                aria-invalid={field?.invalid}
              />
              {field.hasErrors && <div role="alert">{field.errors.join(", ")}</div>}
            </div>
          )
        }

        if (field.type === 'file') {
          return (
            <div className='form__dropzone dropzone'>
              <label htmlFor={field.id}>{field.label}</label>
              <div className='dropzone__button'>
                <div className='btn'>
                  <div className='btn-icons'>
                    <div className='file'><File/></div>
                    <div className='upload'><Upload color='#ffffff' /></div>
                  </div>
                  <input
                    ref={field.ref}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                    onClick={field.onClick}
                    accept={field.accept}
                    multiple={field.multiple}
                    onDrop={field.onDrop}
                    name={field.name}
                    type={field.type}
                    id={field.id}
                    placeholder={field.placeholder}
                    aria-required={field.required}
                    disabled={field.disabled}
                    aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                    aria-invalid={field?.invalid}
                  />
                  {field.isUploadingFile && "Uploading..."}
                  {field.fileUploadSuccessful && "Uploaded"}
                  {(!field.isUploadingFile && !field.fileUploadSuccessful) && (
                    <div className='btn-promt'>Drag and drop or <span>Choose File</span></div>
                  )}
                </div>
              </div>
              {field.files ? (
                <div className="dropzone__content">
                  {field.files.map((file) => (<p key={file.name}>{file.name}</p>))}
                </div>
              ) : (
                <div className='dropzone__content'>
                  {field.hasErrors ? (
                    <>
                      <p><strong>There was an issue uploading your file.</strong></p>
                      <div role="alert">{field.errors.join(", ")}</div>
                    </>
                  ) : (
                    <>
                      <p>Supported files: {field.options.map(x => x.label).join(", ")}</p>
                      <p>Maximum File Size: 10MB</p>
                    </>
                  )}
                </div>
              )}
            </div>
          )
        }

        if (field.type === "textarea") {
          return (
            <div className='form__textarea'>
              <label htmlFor={field.id}>{field.label}</label>
              <textarea
                ref={field.ref}
                onBlur={field.onBlur}
                onChange={field.onChange}
                name={field.name}
                id={field.id}
                placeholder={field.placeholder}
                aria-required={field.required}
                disabled={field.disabled}
                aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                aria-invalid={field?.invalid}
              />
              {field.hasErrors && <div role="alert">{field.errors.join(", ")}</div>}
            </div>
          )
        }

        if (field.type === "select") {
          const options = field.options.map((o) => ({ value: o.value, label: o.label }));

          const handleTypeSelect = (e) => {
            // Update the form’s field as usual
            const event = { target: { name: field.name, value: e.value } };
            field.onChange(event);

            // If this select is the venue picker, update the lead-form-id
            const possibleVenue = e.label || e.value;
            if (field.name === 'venue' || field.label === 'Venue') {
              setLeadFormId(VENUE_TO_FORMID[possibleVenue]);
              setLocationId(VENUE_TO_LOCATIONID[possibleVenue]);
            }
          };

          return (
            <>
              {field.name === 'beds' && <p className='form__p'>I’m interested in properties that have</p>}
              <div className={`form__select form__select--${field.name}`}>
                <label htmlFor={field.id}>{field.label}</label>
                <Select
                  classNamePrefix='react-select'
                  ref={field.ref}
                  onBlur={field.onBlur}
                  onChange={handleTypeSelect}
                  id={field.id}
                  name={field.name}
                  aria-required={field.required}
                  disabled={field.disabled}
                  aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                  aria-invalid={field?.invalid}
                  options={options}
                  placeholder={field.placeholder}
                />
                {field.hasErrors && <div role="alert">{field.errors.join(", ")}</div>}
              </div>
            </>
          )
        }

        if (field.type === "radio") {
          return (
            <div className='form__radio'>
              <div>{field.label}</div>
              {field.options.map((option) => (
                <div className='form__radio-wrapper' key={option.id}>
                  <input
                    id={option.id}
                    type="radio"
                    value={option.value}
                    ref={field.ref}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                    name={field.name}
                    aria-required={field.required}
                    disabled={field.disabled}
                    aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                    aria-invalid={field?.invalid}
                  />
                  <label htmlFor={option.id}>{option.label}</label>
                </div>
              ))}
              {field.hasErrors && <div role="alert">{field.errors.join(", ")}</div>}
            </div>
          )
        }

        if (field.type === "checkbox") {
          return (
            <div className={`form__checkbox${field.label === 'Property Management' ? ' form__checkbox--last' : ''}${field.label === 'Request Section 32' ? ' form__checkbox--hide' : ''}`}>
              <input
                type="checkbox"
                ref={field.ref}
                onBlur={field.onBlur}
                onChange={field.onChange}
                name={field.name}
                id={field.id}
                aria-required={field.required}
                disabled={field.disabled}
                aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                aria-invalid={field?.invalid}
                defaultChecked={field.label === 'Request Section 32' && props.sectionThirtyTwo ? true : undefined}
              />
              <label htmlFor={field.id}>{field.label}</label>
              {field.hasErrors && <div role="alert">{field.errors.join(", ")}</div>}
            </div>
          )
        }

        if (field.type === "checkboxes") {
          return (
            <div className='form__checkboxes'>
              <label className='form__checkboxes-label'>{field.label}</label>
              {field.options.map((option) => (
                <div className="form__checkbox" key={option.id}>
                  <input
                    type="checkbox"
                    ref={field.ref}
                    onBlur={field.onBlur}
                    onChange={field.onChange}
                    name={field.name}
                    id={option.id}
                    aria-required={field.required}
                    disabled={field.disabled}
                    aria-errormessage={field.hasErrors ? field.errors.join(", ") : undefined}
                    aria-invalid={field?.invalid}
                    value={option.value}
                  />
                  <label htmlFor={option.id}>{option.label}</label>
                </div>
              ))}
              {field.hasErrors && <div role="alert">{field.errors.join(", ")}</div>}
            </div>
          )
        }

        return <div>field</div>
      }}
      renderApiErrors={({ errors }) => (
        <div role="alert" className="api-error">{errors.join(", ")}</div>
      )}
      renderSubmitButton={({ children }) => (
        <div className='form__submit'><button className='btn' type="submit">{children}</button></div>
      )}
      renderConfirmationMessage={({ message }) => (
        <div className='form__confirmation'>{message}</div>
      )}
      renderLoadingSpinner={() => <div className='form__loading'><Loading /></div>}
    />
  )
}

export default FormComponent
